import { push } from 'connected-react-router';
import { IntlProvider } from "react-intl";

/**
* 指定日時のUtcTicksを取得します。
* @param {int} offsetHour : 現在時間からのタイムスパン(時)
*/
export const  getUtcTicks = function (offsetHour) {

    var now = new Date();
    var targetDate = new Date();
    targetDate.setHours(now.getHours() + offsetHour);

    // 10,000 ticks in 1 millisecond
    // jsTicks is number of ticks from midnight Jan 1, 1970
    var jsTicks = targetDate.getTime() * 10000;

    // add 621355968000000000 to jsTicks
    // netTicks is number of ticks from midnight Jan 1, 01 CE
    var netTicks = jsTicks + 621355968000000000;

    // UTCに変換
    var utcOffset = new Date().getTimezoneOffset() * 600000000;
    var utcTicks = netTicks - utcOffset;

    return utcTicks;
}
export const getDateTimeFromUtcTicks = function (offsetHour) {

    var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // Convert timestamp to milliseconds
    var date = new Date(offsetHour * 1000);

    // Year
    var year = date.getFullYear();

    // Month
    var month = months_arr[date.getMonth()];

    // Day
    var day = date.getDate();

    // Hours
    var hours = "0" + date.getHours();

    // Minutes
    var minutes = "0" + date.getMinutes();

    // Seconds
    var seconds = "0" + date.getSeconds();

    // Display date time in yyyy-MM-dd h:m:s format
    var convdataTime = year + '-' + month + '-' + day + ' ' + hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

    return convdataTime;
}
export const getDateValueFromUtcTicks = function (utcticks) {

    // UTCから変換
    //var utcOffset = new Date().getTimezoneOffset() * 600000000;
    //var netticks = utcticks + utcOffset;
    var netticks = utcticks + 0;

    // remove 621355968000000000 from netTicks
    // netTicks is number of ticks from midnight Jan 1, 01 CE
    var jsTicks = netticks -  621355968000000000;

    // 10,000 ticks in 1 millisecond
    var jstime = Math.floor(jsTicks / 10000);

    return (jstime);
}

//
// CORS対応API　認証トークンの自動リフレッシュ
//

// できるだけユニークなIDの生成
export const getUniqueStr = () => {
    var strong = 1000; // 桁数
    return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16)
}

// 指定された時間待つだけの関数(ミリ秒)
export const waitAsync = (ms) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

// 国際化対応ライブラリ
var intlProvider = null;
var intl;

// 共通メソッドの国際化対応ライブラリを初期化
export const initIntl = (locale, messages) => {

    intlProvider = new IntlProvider({ locale, messages }, {});
    intl = intlProvider.getChildContext().intl;
}

export const getIntlMessage = (id, values) => {
    var ret = intl.formatMessage(id, values);
    return ret;
}

export const formatDate = (date, format) => {

    const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    format = format.replace('YYYY', date.getFullYear());
    format = format.replace('MMM', monthList[date.getMonth()]);
    format = format.replace('MM', ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace('DD', ('0' + date.getDate()).slice(-2));

    format = format.replace('HH', ('0' + date.getHours()).slice(-2));
    format = format.replace('mm', ('0' + date.getMinutes()).slice(-2));

    return format;
}

// 日時の表示用文字列取得
export const getDateTimeDisplayString = (time) => {
    var date = new Date(time);
    var now = new Date();
    var format = '';

    //【日本語用】
    //YYYY/MM/DD HH:mm   →  2019/06/13 16:30
    //MM/DD HH:mm        →  06/13 16:30
    //HH:mm              →  16:30

    //【英語用】
    //DD/MMM/YYYY HH:mm  →  13/Jul/2019 16:30
    //DD/MMM HH:mm       →  13/Jul 16:30
    //HH:mm              →  16:30

    if (date.getFullYear() != now.getFullYear()) {
        format = getIntlMessage({ id: "DateFormat.LongDateTime" });
    }
    else if (date.getMonth() != now.getMonth() || date.getDate() != now.getDate()) {
        format = getIntlMessage({ id: "DateFormat.ShortDateTime" });
    }
    else {
        format = getIntlMessage({ id: "DateFormat.Time" });
    }

    var ret = formatDate(date, format);
    return ret;
};

// 法人種別コード種別取得
export const getShopCdtype = (shop_cd_type) => {
    var shopCdtype = '';
    switch (shop_cd_type) {
        case 1:
            // OKICA独自
            shopCdtype = getIntlMessage({ id: "Merchant.CorporateCodeTypeOkica" });
            break;
        case 2:
            // JPQR
            shopCdtype = getIntlMessage({ id: "Merchant.CorporateCodeTypeJPQR" });
            break;
    }
    return shopCdtype;
};

// 小数点以下２桁の数値に整形します
export const formatFeeNumber = (doublevalue) => {
    return Math.round(doublevalue * 100) / 100;
}

// 「<yyyy/mm/dd> ～ <yyyy/mm/dd>」形式の文字列を返す
// 手数料一覧で使用
export const formatPeriod = (from, to) => {
    let fdt = new Date(from);
    let fromDt = fdt.getFullYear() + '/' + ("0" + (fdt.getMonth() + 1)).slice(-2) + '/' + ("0" + fdt.getDate()).slice(-2);
    let tdt = new Date(to);
    let toDt = tdt.getFullYear() + '/' + ("0" + (tdt.getMonth() + 1)).slice(-2) + '/' + ("0" + tdt.getDate()).slice(-2);
    return fromDt + " ～ " + toDt;
}

// 指定した日付のn日後を返却（yyyy-mm-dd形式）
// 手数料一覧で使用
export const nextDate = (date, day) => {
    var targetDate = new Date(date);
    targetDate.setDate(targetDate.getDate() + day);
    var nextDate = new Date(targetDate);
    var nextDay = nextDate.toISOString().slice(0, 10);
    return nextDay;
}

// 小数点有りの減算処理（value1 - value2の結果を取得）
// ポイント管理で使用
export const calcSubtract = (value1, value2) => {

    // それぞれの小数点の位置を取得
    var dotPosition1 = getDotPosition(value1);
    var dotPosition2 = getDotPosition(value2);

    // 位置の値が大きい方（小数点以下の位が多い方）の位置を取得
    var max = Math.max(dotPosition1, dotPosition2);

    // 大きい方に小数の桁を合わせて文字列化、
    // 小数点を除いて整数の値にする
    var intValue1 = parseInt((value1.toFixed(max) + '').replace('.', ''));
    var intValue2 = parseInt((value2.toFixed(max) + '').replace('.', ''));

    // 10^N の値を計算
    var power = Math.pow(10, max);

    // 整数値で引き算した後に10^Nで割る
    return (intValue1 - intValue2) / power;

}

// private 小数点の位置を取得
function getDotPosition(value) {

    // 数値のままだと操作できないので文字列化する
    var strVal = String(value);
    var dotPosition = 0;

    //　小数点が存在するか確認
    if (strVal.lastIndexOf('.') === -1) {
        // 小数点があったら位置を取得
        dotPosition = (strVal.length - 1) - strVal.lastIndexOf('.');
    }

    return dotPosition;
}
